import { Doc } from '@dadohr/shared/domainTypes/document';
import {
  DEMO_ORG_IDS,
  IOrganization,
  OrganizationTier
} from '@dadohr/shared/domainTypes/org';
import { FS } from '@dadohr/shared/versions';
import shortid from 'shortid';

import { store, useMappedLoadingValue } from '../../../services/firebase';
import {
  CollectionListener,
  createSingleCollectionListenerStore,
  useCollectionListener
} from '../../../services/firecache/collectionListener';
import { toOrgDoc } from '../../../services/orgs/documents';
import { now } from '../../../services/time';

export const isDemoCompany = (orgId: string) => {
  return DEMO_ORG_IDS.includes(orgId);
};

const orgsCollection = () => store().collection(FS.orgs);
const getOrgsListener = createSingleCollectionListenerStore(
  () => new CollectionListener(orgsCollection(), toOrgDoc)
);

export const getAllOrgs = () => {
  return getOrgsListener().get();
};

export const getAllOrgIds = () => {
  return orgsCollection()
    .get()
    .then((s) => s.docs.map((d) => d.id));
};

export const useAllOrgs = () => {
  return useCollectionListener(getOrgsListener());
};

export const useOrgById = (orgId: string) => {
  return useMappedLoadingValue(
    useAllOrgs(),
    (orgs) => orgs.find((o) => o.id === orgId) || null
  );
};

export const getNewOrgDoc = (vs: {
  name: string;
  domain: string;
  tz: string;
}) => {
  const orgId = shortid();
  const org: Doc<IOrganization> = {
    id: orgId,
    collection: FS.orgs,
    data: {
      id: orgId,
      name: vs.name,
      domain: vs.domain,
      logoUrl: '',
      logoInvertedUrl: '',
      createdAt: now(),
      createdBy: 'EMPLEXP',
      features: {},
      permissions: {},
      dateFormats: {
        MMDDYYYY: 'MM/DD/YYYY'
      },
      tz: vs.tz,
      defaultExperienceStartHour: 9,
      customUserFields: [],
      experienceTheming: null,
      salutations: null,
      fallbackSalutations: null,
      customHints: null,
      sso: {
        enabledForAdmins: false,
        enabledForEndUsers: false
      },
      termsOfServiceAndPrivacyPolicy: null,
      subscription: null,
      tier: OrganizationTier.STANDARD
    }
  };
  return org;
};
